export default "<app-photo-editor [source]=\"element\" (result)=\"resultReceiver($event)\"></app-photo-editor>"